var _path, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdobeAeSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "adobe_ae") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19,5V19H5V5H19m0-2H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V5a2,2,0,0,0-2-2Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.43,15.89,10.86,14H8l-.57,1.87H5.63L8.4,8h2l2.78,7.89Zm-1-3.27c-.53-1.69-.82-2.65-.89-2.87s-.11-.4-.14-.53c-.12.46-.46,1.59-1,3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.92,16a3.13,3.13,0,0,1-2.27-.8,3.06,3.06,0,0,1-.81-2.27,3.33,3.33,0,0,1,.75-2.33,2.69,2.69,0,0,1,2.09-.83,2.61,2.61,0,0,1,2,.73,2.74,2.74,0,0,1,.71,2v.79H14.5a1.52,1.52,0,0,0,.41,1.09,1.43,1.43,0,0,0,1.08.4,4.22,4.22,0,0,0,1-.12,4.56,4.56,0,0,0,1-.36v1.27a4,4,0,0,1-.92.32A5.67,5.67,0,0,1,15.92,16Zm-.23-5.06a1,1,0,0,0-.82.33,1.51,1.51,0,0,0-.34.93h2.3a1.34,1.34,0,0,0-.32-.93A1.06,1.06,0,0,0,15.69,10.94Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdobeAeSvgrepoCom);
export default __webpack_public_path__ + "static/media/adobe-ae-svgrepo-com.14ac658ee66dc1b26d5f6b0d83747b2c.svg";
export { ForwardRef as ReactComponent };